import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";

export default function ResetConfirmDialog(props) {
    const { open, onClose, onConfirm } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="reset-dialog-title"
            aria-describedby="reset-dialog-description"
        >
            <DialogTitle id="reset-dialog-title">Start Over?</DialogTitle>
            <DialogContent>
                <DialogContentText id="reset-dialog-description">
                    Are you sure you want to start over? All current progress
                    and data will be lost.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    autoFocus
                >
                    Start Over
                </Button>
            </DialogActions>
        </Dialog>
    );
}
